/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Immutable from 'immutable';


export default (planet) =>
{
  let state = new Immutable.Map();

  for (const user of planet.getUsers())
  {
    state = state.set(user.getID(), user.getType());
  }

  return state;
}
